import { Button, Flex, HStack, Text } from '@chakra-ui/react';

import type { AssignmentFormData } from '../../../types/assignmentTypes';
import { CheckCircle } from '@/client/components/icons/ContinuIcons';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export default function AssignmentBulkImportView() {
  const { t } = useTranslation();
  const { setValue, watch } = useFormContext<AssignmentFormData>();

  const { bulkAudienceImportData, audience } = watch();

  const { bulkImportFileName } = bulkAudienceImportData;

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      paddingY={3}
      paddingX={4}
      backgroundColor="warmNeutral.0"
      border="1px solid"
      borderColor="warmNeutral.700"
      borderRadius="6px"
    >
      <HStack spacing={2}>
        <CheckCircle color="warmNeutral.700" boxSize={6} />

        <Text fontSize="14px" fontWeight={500}>
          {bulkImportFileName}
        </Text>
      </HStack>

      <HStack spacing={4}>
        <Text fontSize="14px" fontWeight={500}>
          {audience.length} {t('admin.assignments.step.audience.totalCount.users')}
        </Text>

        <Button
          size="sm"
          backgroundColor="white"
          border="1px solid"
          borderColor="warmNeutral.200"
          borderRadius="8px"
          color="baseBlack"
          fontSize="12px"
          fontWeight={600}
          _hover={{
            backgroundColor: 'white',
          }}
          onClick={() => {
            setValue('audience', []);

            setValue('bulkAudienceImportData', {
              usesBulkAudienceImport: false,
              bulkImportFileName: '',
            });
          }}
        >
          {t('admin.assignments.step.audience.import.remove')}
        </Button>
      </HStack>
    </Flex>
  );
}
